export async function loadDictationOrganizer() {
    return import("@/lib/actions/dictation-actions");
}
